import React from 'react'

import { OrgType, useCurOrg } from '~/hooks/state'

function createTenantTypeUIProvider<T>(
  type: OrgType
): React.FC<React.PropsWithChildren<T>> {
  return (({ children }) => {
    const { curOrg } = useCurOrg()
    const { orgType } = curOrg!

    return orgType === type ? children : null
  }) as React.FC<React.PropsWithChildren<T>>
}

export const OnPremUIProvider: React.FC<React.PropsWithChildren> =
  createTenantTypeUIProvider(OrgType.OnPrem)

export const CloudUIProvider: React.FC<React.PropsWithChildren> =
  createTenantTypeUIProvider(OrgType.Cloud)

export const TenantTypeUIProvider: React.FC<
  React.PropsWithChildren<{
    type: OrgType | OrgType[]
  }>
> = ({ type, children }) => {
  const { curOrg } = useCurOrg()
  const { orgType } = curOrg!

  let isChildrenVisible = false
  if (Array.isArray(type)) {
    isChildrenVisible = type.includes(orgType as OrgType)
  } else {
    isChildrenVisible = orgType === type
  }
  return (isChildrenVisible ? children : null) as any
}
